export { default } from './useHigherEducation';
